export default "__VITE_ASSET__vpwNRg2T__"